import { render } from "./home-item.vue?vue&type=template&id=4396d081"
import script from "./home-item.vue?vue&type=script&lang=js"
export * from "./home-item.vue?vue&type=script&lang=js"

import "./home-item.vue?vue&type=style&index=0&id=4396d081&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__